import { render, staticRenderFns } from "./ErrorsLayout.vue?vue&type=template&id=7b78265e&lang=pug&"
import script from "./ErrorsLayout.vue?vue&type=script&lang=js&"
export * from "./ErrorsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports